import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';

const RegionalLookthroughChart = forwardRef(({ data, colours = {} }, ref) => {
  if (!data || !data.data || data.data.length === 0) {
    return <div className="chart-placeholder">No regional exposure data available</div>;
  }

  const primaryColor = colours.chart_primary || '#337B91';
  const secondaryColor = colours.chart_secondary || '#BBCBD7';

  const items = data.data;
  const benchmarkName = data.benchmark_name || 'MSCI ACWI';

  const chartData = {
    labels: items.map(d => d.region),
    datasets: [
      {
        label: data.portfolio_label || 'Portfolio',
        data: items.map(d => d.portfolio_weight ?? 0),
        backgroundColor: primaryColor,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
      {
        label: benchmarkName,
        data: items.map(d => d.benchmark_weight ?? 0),
        backgroundColor: secondaryColor,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: { font: { size: 10 }, boxWidth: 20, boxHeight: 2, padding: 5 },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { display: false },
        ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
      },
      y: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val}%`,
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <Bar ref={ref} data={chartData} options={options} />
      </div>
      <p style={{ fontSize: '6pt', color: '#6c757d', marginTop: '2px' }}>Source: Drummond Capital Partners, Fund Managers</p>
    </div>
  );
});

RegionalLookthroughChart.displayName = 'RegionalLookthroughChart';
export default RegionalLookthroughChart;
